<template>
  <v-card-text>
    <v-card outlined>
      <v-simple-table dense class="position-table">
        <template v-slot:default>
          <tbody>
            <tr
              v-for="crewCombination in crewCombinations"
              :key="crewCombination.id"
            >
              <!-- Position Name -->
              <td class="font-weight-medium">
                <v-chip
                  small
                  label
                  :color="
                    getChipColor(
                      crewCombination.fulfillmentStatus.status,
                      crewCombination.fulfillmentStatus
                    )
                  "
                  class="font-weight-medium"
                >
                  <v-icon left x-small>
                    {{
                      getStatusIcon(crewCombination.fulfillmentStatus.status)
                    }}
                  </v-icon>
                  {{ crewCombination.title }}
                </v-chip>
              </td>
              <td>
                <v-chip
                  v-if="crewCombination.isBestOption"
                  label
                  small
                  color="green lighten-4 green--text text--darken-4"
                  class="font-weight-medium"
                >
                  <v-icon left x-small>mdi-star</v-icon>
                  Beste Option
                </v-chip>
                <span class="red--text">
                  {{ crewCombination.fulfillmentStatus.missingText }}
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-card-text>
</template>

<script>
import { getChipColor, getStatusIcon } from "@/util/statusUtils";

export default {
  name: "CrewCombinationsSummary",
  props: {
    crewCombinations: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getChipColor,
    getStatusIcon,
  },
};
</script>

<style scoped>
.position-table {
  border-radius: 4px;
  overflow: hidden;
}
</style>
